import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import SignIn from './views/SignIn.vue'
import Home from './views/Home.vue'
import HomeExaminationInfo from './views/HomeExaminationInfo.vue'
import EmptyExaminationInfo from './views/EmptyExaminationInfo.vue'
import ExaminationDetail from './views/ExaminationDetailPage.vue'
import ReportPreview from './views/ReportPreview.vue'
import ReportDetail from './views/ReportDetailPage.vue'
// import Print from './views/Print.vue'
const TestPage = () => import(/* webpackChunkName: "test" */ './views/TestPage')

import AdminOrganizationList from './views/admin/OrganizationList'
import AdminDoctorList from './views/admin/DoctorList'
import AdminEmployeeTypeList from './views/admin/EmployeeTypeList'
import AdminExaminationList from './views/admin/ExaminationList2'
import AdminExaminationTypeList from './views/admin/ExaminationTypeList'
import AdminLandmarkList from './views/admin/LandmarkList'
import AdminInspectionInstrumentList from './views/admin/InspectionInstrumentList'
import AdminWashInstrumentList from './views/admin/WashInstrumentList'
import AdminAntiplateletList from './views/admin/AntiplateletList'
import AdminAntispasmodicList from './views/admin/AntispasmodicList'
import AdminCleanMedList from './views/admin/CleanMedList'
import AdminSedativeList from './views/admin/SedativeList'
import AdminPatientList from './views/admin/PatientList2'
import AdminTechnicalStaffList from './views/admin/TechnicalStaffList'
import AdminUserList from './views/admin/UserList'
import AdminAnalytics from './views/admin/Analytics'
import AdminAnalyticsSearch from './views/admin/AnalyticsSearch'
import AdminAnalyticsPDR from './views/admin/AnalyticsPDR'
import AdminAnalyticsSixMin from './views/admin/AnalyticsSixMin'
import AdminAnalyticsIntervention from './views/admin/AnalyticsIntervention'
import AdminAnalyticsUsage from './views/admin/AnalyticsUsage'

import { store } from './store/index'
import { authServices } from '@/services/auth'
import routesUtils from '@/utils/routes'

Vue.use(Router)
Vue.use(Meta, {
  name: 'google-site-verification',
  content: '0-5MfY6ZO4XXkIE-y0mFs7vPcgmCFy7TJMskeNNqNCw'
})

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'SignIn',
      component: SignIn,
    },
    {
      path: '/test',
      name: 'test',
      component: TestPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/home',
      component: Home,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          component: EmptyExaminationInfo
        },
        {
          path: ':examinationID',
          component: HomeExaminationInfo
        }
      ]
    },
    {
      path: '/reports/:examinationID/accNo/:accNo',
      name: 'ReportDetail',
      meta: { requiresAuth: true },
      component: ReportDetail
    },
    // {
    //   path: '/reports/:examinationID/accNo/:accNo/print',
    //   name: 'print',
    //   meta: { requiresAuth: true },
    //   component: Print
    // },
    {
      path: '/reports/:examinationID/accNo/:accNo/preview',
      name: 'ReportPreview',
      meta: { requiresAuth: true },
      component: ReportPreview
    },
    {
      path: '/examinations/:examinationID/accNo/:accNo',
      meta: { requiresAuth: true },
      component: ExaminationDetail
    },

    ...routesUtils.withPrefix('/admin/', [
      {
        path: 'organization-list',
        component: AdminOrganizationList
      },
      {
        path: 'doctor-list',
        component: AdminDoctorList
      },
      {
        path: 'employeeType-list',
        component: AdminEmployeeTypeList
      },
      {
        path: 'examination-list',
        component: AdminExaminationList
      },
      {
        path: 'examinationType-list',
        component: AdminExaminationTypeList
      },
      {
        path: 'landmark-list',
        component: AdminLandmarkList
      },
      {
        path: 'inspectionInstrument-list',
        component: AdminInspectionInstrumentList
      },
      {
        path: 'washInstrument-list',
        component: AdminWashInstrumentList
      },
      {
        path: 'antiplatelet-list',
        component: AdminAntiplateletList
      },
      {
        path: 'antispasmodic-list',
        component: AdminAntispasmodicList
      },
      {
        path: 'cleanMed-list',
        component: AdminCleanMedList
      },
      {
        path: 'sedative-list',
        component: AdminSedativeList
      },
      {
        path: 'patient-list',
        component: AdminPatientList
      },
      {
        path: 'technicalStaff-list',
        component: AdminTechnicalStaffList
      },
      {
        path: 'user-list',
        component: AdminUserList
      },
      {
        path: 'analytics',
        component: AdminAnalytics,
        children: [
          { path: 'search', component: AdminAnalyticsSearch },
          { path: 'pdr', component: AdminAnalyticsPDR },
          { path: 'six-min', component: AdminAnalyticsSixMin },
          { path: 'intervention', component: AdminAnalyticsIntervention },
          { path: 'usage', component: AdminAnalyticsUsage },
          { path: '', redirect: '/admin/analytics/search' }
        ]
      }
    ])
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  authServices
    .validateAuthState()
    .then(res => {
      if (res.result === 'success') {
        const user = {
          username: res.username,
          name: res.name,
          level: Number(res.level),
          orgName: res.orgName
        }

        // if is authenticated and this page requires authentication
        if (requiresAuth && !user) {
          next('/')
          return
        }

        store.commit('setUser', user)

        switch (to.path) {
          case '/':
            if (user) {
              next('/home')
            }
            break;
          case '/admin/organization-list':
            if (!user) {
              next('/home')
            }
            break;
          case '/admin/doctor-list':
            if (!user) {
              next('/home')
            }
            break;
          case '/admin/employeeType-list':
            if (Number(res.level) != 9) {
              next('/home')
            }
            break;
          case '/admin/examination-list':
            if (!user) {
              next('/home')
            }
            break;
          case '/admin/examinationType-list':
            if (Number(res.level) != 9) {
              next('/home')
            }
            break;
          case '/admin/landmark-list':
            if (Number(res.level) != 9) {
              next('/home')
            }
            break;
          case '/admin/inspectionInstrument-list':
            if (!user) {
              next('/home')
            }
            break;
          case '/admin/washInstrument-list':
            if (!user) {
              next('/home')
            }
            break;
          case '/admin/antiplatelet-list':
            if (Number(res.level) != 9) {
              next('/home')
            }
            break;
          case '/admin/antispasmodic-list':
            if (Number(res.level) != 9) {
              next('/home')
            }
            break;
          case '/admin/cleanMed-list':
            if (Number(res.level) != 9) {
              next('/home')
            }
            break;
          case '/admin/sedative-list':
            if (Number(res.level) != 9) {
              next('/home')
            }
            break;
          case '/admin/patient-list':
            if (!user) {
              next('/home')
            }
            break;
          case '/admin/technicalStaff-list':
            if (!user) {
              next('/home')
            }
            break;
          case '/admin/user-list':
            if (Number(res.level) != 9) {
              next('/home')
            }
            break;
          case '/admin/analytics':
            if (!user) {
              next('/home')
            }
            break;
      }

        next()

      } else {
        // sign user out and go back to sign in page
        let temp_path = to.path.split('/');
        if (temp_path[1] == 'examinations' && temp_path[3] == 'accNo') {
            
        } else {
            store.dispatch('userSignOut')
        }
      }
    })
    .catch(e => {
      console.log('error when validating auth state:', e)
    })

  next()
})


export default router

